const convertToSuperscript = (text) => {
  return text
    .replaceAll('©', '<sup>©</sup>')
    .replaceAll('™', '<sup>™</sup>')
    .replaceAll('®', '<sup>®</sup>');
};

export default convertToSuperscript;
